import { getHandlers } from '@vlabs/api/artemy/client';
import type { HandlerRecord } from '@vlabs/api/artemy/model';

import {
  OPTIONS_PAGE_SIZE,
  toSourceGroupOptions,
} from './group-options';

/** Опция обработчика: label — название, value — handler_id. */
export interface HandlerOption {
  label: string;
  value: string;
}

export async function loadHandlerOptions(): Promise<HandlerOption[]> {
  const { handlers } = await getHandlers({ page: 1, page_size: OPTIONS_PAGE_SIZE });

  return toSourceGroupOptions((handlers ?? []).map(
    (handler: HandlerRecord): HandlerOption => ({
      label: handler.description ?? handler.handler_id ?? '',
      value: handler.handler_id ?? '',
    }),
  ));
}
